// @core/api/endpoints/userprofile/ban_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BanUserprofileRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Ban user profile
 * Bans a user profile, preventing all activity and hiding it from other users. Requires a reason and optionally an expiration date for temporary bans.
 */
export async function BanUserprofile(
  profile_id: string,
  data: BanUserprofileRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/ban`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
